import { TagGroupInfoFragment } from 'generated/graphql';

interface TagFilterFunctionOptions {
  availableTagCategories: Array<{ id: string }>;
  canExportTags: boolean;
}

export function tagFilterFunction({
  availableTagCategories,
  canExportTags
}: TagFilterFunctionOptions) {
  const tagCategoryIds = availableTagCategories.map(tc => tc.id);

  return (groups: TagGroupInfoFragment[]) => {
    if (canExportTags && tagCategoryIds.length === 0) {
      return groups;
    }

    const groupsByTag = [];
    groups.map((tagGroup) => {
      const filteredCategories = tagGroup.categories
        .filter(currentCategory => tagCategoryIds.includes(currentCategory.id));
      if (filteredCategories.length > 0) {
        groupsByTag.push({ ...tagGroup, ...{ categories: filteredCategories } });
      }
    });
    return groupsByTag;
  };
}
